export default "__VITE_ASSET__CRjJeNw___"